// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// D-CRX-82 — TanStack Query hooks for the e-sign email controls (E-02: components never call api.* directly).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import * as api from '../../api/esignSettings'

export const esignSettingsKeys = { all: ['esign-settings', 'me'] as const }

export function useEsignSettings() {
  return useQuery({ queryKey: esignSettingsKeys.all, queryFn: api.getMyEsignSettings, staleTime: 60_000 })
}

/** Saves ONE document type; the cached row is replaced with what the server stored (normalised). */
export function useSaveEsignSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (s: api.EsignEmailSettings) => api.putMyEsignSettings(s),
    onSuccess: saved => {
      qc.setQueryData<api.EsignEmailSettingsResponse>(esignSettingsKeys.all, prev => prev && {
        ...prev, settings: prev.settings.map(r => (r.doc_type === saved.doc_type ? saved : r)),
      })
    },
  })
}
